module.exports = __webpack_public_path__ + "static/media/lead_followed_up_img.bf5d7793.svg";